import $ from 'jquery';
import { setAnalyticsEvents } from 'util/analytics';
import { initAutosubmit } from 'util/autosubmit';
import { EVT_VKEY_BEFORE_UPDATE, EVT_VKEY_AFTER_UPDATE } from 'util/constants';
import * as deferred from 'util/deferred';
import { $window } from 'util/global';
import * as latexLoader from 'util/latex_loader';
import { initGenericControllers } from 'app/generic_controllers';

window.vkey = window.vkey || {};

/**
 * Default handler.
 * To use in your callbacks:
 *     const $root = vkey.handle(action, actionKey) - $root is jQuery object for component
 * @param {object} action
 * @param {string} actionKey
 * @returns {JQuery}
 */
window.vkey.handle = (action, actionKey) => {
  let $cmp = $(`#cmp_${actionKey}_id`);
  if ($cmp.length === 0) {
    $cmp = $(`.cmp_${actionKey}_id`);
  }

  $window.trigger($.Event(`${EVT_VKEY_BEFORE_UPDATE}.${action.component_key}`, { $cmp }));

  $cmp.html(action.new_html);
  initAutosubmit($cmp);
  initGenericControllers($cmp);
  setAnalyticsEvents($cmp);

  $window.trigger($.Event(`${EVT_VKEY_AFTER_UPDATE}.${action.component_key}`, { $cmp }));

  latexLoader.loadForElement($cmp);

  // load all the deferred components inside this component if there are any
  $cmp.find('.cmp-deferred').each((i, cmp) => {
    deferred.add($(cmp));
  });
  return $cmp;
};
